import { ButtonType } from "../../types/ui-pattern-types/button-types";

const Button: React.FunctionComponent<ButtonType> = (
  {
    children,
    style,
    variant = "primary",
    size = "medium",
    className,
    onClick,
    disabled,
    type,
  },
  props,
) => {
  const buttonClassName = !disabled
    ? `clamp_button m-5 clamp_button-${variant} clamp_button-${size} ${className}`
    : `clamp_button-disabled clamp_button-${variant}-disabled clamp_button-${size} ${className}`;

  return (
    <button
      className={buttonClassName}
      disabled={disabled}
      onClick={onClick}
      style={style}
      type={type}
      {...props}
    >
      <div className="button-shadow-container">
        <div className="button-content-container">{children || "BUTTON"}</div>
      </div>
    </button>
  );
};

export default Button;
